import {Alert, Backdrop} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import {
  CannotDeletePromptModalWrapper,
  ContentAlert,
  AlertTitle,
  AlertMessage,
  ListAgentsCounterWrapper,
  ListAgentsCounterTitle,
  ListAgentsCounterNumber,
  ListAgentsWrapper,
  ListAgentsContainer,
  ListAgentsContainerItems,
  ListAgentsItem, 
  ActionsWrapper,
  CannotDeletePromptModalCloseButton,
  AgentAvatarWrapper,
  AgentName,
  AgentTeam
} from "./CannotDeletePromptModal.styled";
import {Icon, IconButton, RoundedButton} from "../../../../../elements";
import {DefaultTheme as theme} from "../../../../../theme";

export const CannotDeletePromptModal = ({ isOpen, agents }) => {
  const [openModal, setOpenModal] = useState(isOpen);

  useEffect(() => {
    setOpenModal(isOpen);
  }, [isOpen]);
  
  const onHandleClose = useCallback(() => {
    setOpenModal(false);
  }, []);
  
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={openModal}
    >
      <CannotDeletePromptModalWrapper>
        <CannotDeletePromptModalCloseButton>
          <IconButton icon="close" width="16px" height="16px" onClick={onHandleClose} dataTestId="close-modal-button" />
        </CannotDeletePromptModalCloseButton>
        <Alert severity="warning">
          <ContentAlert>
            <AlertTitle>Cannot delete prompt</AlertTitle>
            <AlertMessage>This prompt cannot be deleted because it is currently being used by multiple agents.
              To delete it, first unlink it from all associated agents</AlertMessage>
          </ContentAlert> 
        </Alert>
        <ListAgentsCounterWrapper>
          <ListAgentsCounterTitle>Content summary to delete:</ListAgentsCounterTitle>
          <ListAgentsCounterNumber>{agents?.length} agents</ListAgentsCounterNumber>
        </ListAgentsCounterWrapper>
        <ListAgentsWrapper>
          <ListAgentsContainer>
            <ListAgentsContainerItems>
              {agents?.map((agent) => (
                <ListAgentsItem key={agent.name}>
                  <AgentAvatarWrapper>
                    {
                      agent.photo_url && agent.photo_url !== "" 
                        ? (<img alt={agent.name} src={agent.photo_url} />)
                        :(<Icon dataTestId="carbonUserAvatarFilled" name="carbonUserAvatarFilled" width="24px" height="24px" />)
                    }
                  </AgentAvatarWrapper>
                  <AgentName>{agent.name}</AgentName>
                  <AgentTeam>{agent.category}</AgentTeam>
                </ListAgentsItem>
              ))}
            </ListAgentsContainerItems>
          </ListAgentsContainer>
        </ListAgentsWrapper>
        <ActionsWrapper>
          <RoundedButton color={theme.colors.activeBlue} kind={"primary"} width={"70px"} onClick={onHandleClose}>Close</RoundedButton>
        </ActionsWrapper>
      </CannotDeletePromptModalWrapper>
    </Backdrop>
  );
}
